<div class="filter-section" [title]="disabled ? disabledTooltip : ''">
  <div class="filter-label">{{ label }}</div>
  <select
    class="filter-select"
    [(ngModel)]="filterBy"
    (change)="onFilterChange($event)"
    id="tour-filter"
    [disabled]="disabled"
  >
    @for (option of filterByOptions; track option.value) {
      <option [value]="option.value">{{ option.option }}</option>
    }
  </select>
</div>
